import { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./pages/Cigna/Layout";
import Overview from "./pages/Cigna/Overview";
import Coverage from "./pages/Cigna/coverage";
import Edelivery from "./pages/Cigna/Edelivery";
import Settings from "./pages/Cigna/setting";
import Billing from "./components/billing";
import { BillingSummaryProvider } from "./contexts/BillingSummaryContext";
import BillingConfirmation from "./components/billingConfirmation";
import BillingSummary from "./components/billingsummary";
import Region from "./components/Region";
import { LanguageProvider } from "./contexts/LanguageContext";
import LimitedProficiency from "./components/LanguageProficiency";
import Contactus from "./components/Contactus";
import Glossary from "./components/Glossary";
import Faq from "./components/Faq";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Login";
import NonDiscriminationNotice from "./components/NonDiscriminationNotice";
import Logout from "./components/Logout";
import PageNotFound from "./components/PageNotFound";
import SSOCheckAuthCallBack from "./components/SSOCheckAuthCallBack";
import SSOMemberCheck from "./components/SSOMemberCheck";
import SSOExternalLogout from "./components/SSOExternalLogout";
import PrivateLoginRoute from "./components/PrivateLoginRoute";
import Landing from "./components/Landing";
import CarrierValidator from "./components/CarrierValidator";
import Schedulepayment from "./components/schedulepayment";
import Forms from "./components/forms";
import Billinghistory from "./components/billinghistory";
import AutoPayModal from "./components/AutoPay";
import PaymentHistory from "./components/PaymentHistory";
import { LogoutContentProvider } from "./contexts/LogoutContentContext";
import { initializeAccessLogger, useRouteLogger } from "./utils/AccessLogger";
import { CaseInfoProvider } from "./contexts/CaseInfoContext";

function AppContent() {
  // Track route changes
  useRouteLogger();

  return (
    <LanguageProvider>
      <Routes>
        <Route path="login" element={<PrivateLoginRoute><Login /></PrivateLoginRoute>} />
        <Route path="/" element={ <PrivateRoute><CaseInfoProvider><Layout /></CaseInfoProvider></PrivateRoute>}>
          <Route  index element={ <PrivateRoute><Overview /></PrivateRoute>} />
          <Route  path="overview" element={ <PrivateRoute><Overview /></PrivateRoute>}/>
          <Route  path="coverage" element={ <PrivateRoute><Coverage /></PrivateRoute>}/>
          <Route  path="edelivery" element={ <PrivateRoute><Edelivery /></PrivateRoute>}/>
          <Route  path="settings" element={ <PrivateRoute><Settings /></PrivateRoute>}/>
          <Route  path="billing" element={ <PrivateRoute><Billing /></PrivateRoute>}/>
          <Route  path="billing-summary" element={ <PrivateRoute><BillingSummary /></PrivateRoute>}/>
          <Route  path="billing-confirmation" element={ <PrivateRoute><BillingConfirmation /></PrivateRoute>}/>
          <Route  path="limitedproficiency" element={ <PrivateRoute><LimitedProficiency /></PrivateRoute>}/>
          <Route  path="nondiscrimination" element={ <PrivateRoute><NonDiscriminationNotice /></PrivateRoute>}/>
          <Route  path="contactus" element={ <PrivateRoute><Contactus /></PrivateRoute>}/>
          <Route  path="glossary" element={ <PrivateRoute><Glossary /></PrivateRoute>}/>
          <Route  path="faq" element={ <PrivateRoute><Faq /></PrivateRoute>}/>
          <Route path="landing" element={<PrivateRoute><Landing /></PrivateRoute>} />
          <Route path="schedulepayment" element={<PrivateRoute><Schedulepayment /></PrivateRoute>} />
          <Route path="add-account" element={<PrivateRoute><Forms /></PrivateRoute>} />
          <Route path="billinghistory" element={<PrivateRoute><Billinghistory /></PrivateRoute>} />
          <Route path="autopay" element={<PrivateRoute><AutoPayModal /></PrivateRoute>} />
          <Route path="paymenthistory" element={<PrivateRoute><PaymentHistory /></PrivateRoute>} />
        </Route>
        <Route path="SlpMember" element={<Region />} />
        <Route path="logout" element={<LogoutContentProvider><Logout /></LogoutContentProvider>} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="SSOAuthCallBack" element={<SSOCheckAuthCallBack />} />
        <Route path="SSOMemberCheck" element={<SSOMemberCheck />} />
        <Route path="SSOExternal" element={<LogoutContentProvider><SSOExternalLogout /></LogoutContentProvider>} />
      </Routes>
      <ToastContainer />
    </LanguageProvider>
  );
}

function App() {
  // Extract carrier from URL path dynamically (e.g., /cigna, /bcbsaz, etc.)
  // Exclude /logout and /SlpMember from basename
  const getBasename = () => {
    const path = window.location.pathname;
    const carrierMatch = path.match(/^\/([^\/]+)/);
    
    if (!carrierMatch) {
      return '/';
    }
    
    const firstSegment = carrierMatch[1].toLowerCase();
    
    // Exclude these routes from having a basename
    const EXCLUDED_ROUTES = ['logout', 'slpmember', 'login', 'ssoauthcallback', 'ssoexternal'];
    if (EXCLUDED_ROUTES.includes(firstSegment)) {
      return '/';
    }
    
    return `/${carrierMatch[1]}`;
  };

  const basename = getBasename();

  useEffect(() => {
    // Initialize access logger on app startup
    // Track routes and static files only (no API calls)
    const { cleanup } = initializeAccessLogger({
      interceptFetch: false,    // Don't track fetch API calls
      interceptXHR: false,       // Don't track XMLHttpRequest calls
      logResources: true         // Track static files (CSS, JS bundles)
    });

    // Cleanup on unmount
    return () => cleanup();
  }, []);

  return (
    <AuthProvider>
      <BillingSummaryProvider>
        <BrowserRouter basename={basename}>
          <CarrierValidator>
            <AppContent />
          </CarrierValidator>
        </BrowserRouter>
      </BillingSummaryProvider>
    </AuthProvider>
  );
}

export default App;